const DiffEntryLfsIcon = () => (
	<span className="ml-1 pr-1 grid! place-items-center text-[var(--color-merge-request-text)]">
		<span className="text-[0.5em] leading-[1.2] p-[0.1rem]! border-[0.1px] border-[var(--color-merge-request-text)] border-solid rounded-[2px]">
			LFS
		</span>
	</span>
);

export default DiffEntryLfsIcon;
